module.exports = __webpack_public_path__ + "static/media/Bluelab OnePen.4d351e54.webp";